import { DropdownOptionModel } from '../../../../models/Common';

export interface InvoicingAddress {
  firstName: string;
  lastName: string;
  county: DropdownOptionModel;
  counties: DropdownOptionModel[];
  city: DropdownOptionModel;
  cities: DropdownOptionModel[];
  addressLine: string;
  agreeCnp: boolean;
  cnp?: string | null;
}

export enum InvoicingAddressContextTypes {
  MyAccount = 1,
  CartMainAddress = 2,
  CartOtherAddress = 3,
}
